import { render, staticRenderFns } from "./GiftCardsDetails.vue?vue&type=template&id=181e2e62&"
import script from "./GiftCardsDetails.vue?vue&type=script&lang=js&"
export * from "./GiftCardsDetails.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports